import React from 'react';
import {
  Container,
  VerticalTabs,
  Wrapper,
  TabContent,
  ContainerCards,
} from './styles';
import FormDefault from '~/components/FormDefault';
import { Row, Tabs, Tab } from 'react-bootstrap';
import { FormFilters } from './components/FormFilters';
import { Table } from './components/Table';
import { Grafico } from './components/Grafico';
import { useFluxoDeCaixa } from './hook/useFluxoDeCaixa';
import { formatCurrencyAsText } from '~/utils/functions';
import { CustomCards } from './components/CustomCards';
import { FaChartArea } from 'react-icons/fa';
import { FaTeeth } from 'react-icons/fa';

export const FluxoDeCaixaContent: React.FC = () => {
  const { tab, setTab, loading, totalizadores } = useFluxoDeCaixa();

  return (
    <Container>
      <FormDefault
        codTela={315}
        title="Fluxo de Caixa"
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isCancel={false}
        isBackSearch={false}
        isClear={false}
        isSave
      >
        <Row>
          <FormFilters />
        </Row>
        <Wrapper>
          <VerticalTabs>
            <Tabs
              activeKey={tab}
              onSelect={(k) => setTab(k || 'grid')}
              className="flex-column"
            >
              <Tab
                eventKey="graph"
                title={
                  <span className="vertical-tab-content">
                    <FaChartArea className="icon-rotated" />
                    <span className="label">Gráfico</span>
                  </span>
                }
              />
              <Tab
                eventKey="grid"
                title={
                  <span className="vertical-tab-content">
                    <FaTeeth className="icon-rotated" />
                    <span className="label">Grade</span>
                  </span>
                }
              />
            </Tabs>
          </VerticalTabs>

          <TabContent>
            {tab === 'grid' && <Table />}
            {tab === 'graph' && <Grafico />}
          </TabContent>
        </Wrapper>
        <ContainerCards>
          <CustomCards
            loading={loading}
            value={formatCurrencyAsText(totalizadores.val_inicial) || '0,00'}
            label="Saldo Inicial"
            color="#6aa84f"
          />
          <CustomCards
            loading={loading}
            value={
              formatCurrencyAsText(totalizadores.val_total_receber) || '0,00'
            }
            label="Recebimentos Período"
            color="#2b78e4"
          />
          <CustomCards
            loading={loading}
            value={
              formatCurrencyAsText(totalizadores.val_total_pagar) || '0,00'
            }
            label="Pagamentos Período"
            color="#e06666"
          />
          <CustomCards
            loading={loading}
            value={
              formatCurrencyAsText(totalizadores.val_total_consolidado) ||
              '0,00'
            }
            label="Consolidado Período"
            color="#999999"
          />
          <CustomCards
            loading={loading}
            value={formatCurrencyAsText(totalizadores.val_final) || '0,00'}
            label="Saldo Final"
            color="#6aa84f"
          />
        </ContainerCards>
      </FormDefault>
    </Container>
  );
};
